import { useTranslation } from "react-i18next";
import { MotionItem, MotionReveal, MotionStagger } from "./MotionReveal";

export function ValueProp() {
  const { t } = useTranslation("global");
  const pillars = t("valueProp.pillars", { returnObjects: true });

  return (
    <section className="siat-section" id="value">
      <div className="siat-wrap">
        <MotionReveal className="siat-intro">
          <p className="siat-eyebrow">{t("valueProp.eyebrow")}</p>
          <h2>{t("valueProp.title")}</h2>
          <p className="siat-lead">{t("valueProp.lead")}</p>
        </MotionReveal>

        <MotionStagger className="siat-pillars">
          {Array.isArray(pillars) &&
            pillars.map((pillar, index) => (
              <MotionItem
                as="article"
                key={pillar.title}
                className="siat-pillar siat-value__item"
              >
                <span className="siat-pillar__index" aria-hidden="true">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <h3>{pillar.title}</h3>
                <p>{pillar.text}</p>
              </MotionItem>
            ))}
        </MotionStagger>
      </div>
    </section>
  );
}
